import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../redux-store";

type PanelInfos = {
  intialWidth: number;
  open: boolean;
  pinned: boolean;
  activeId: number | null;
};

type PlayerInfos = {
  responsive: boolean;
  height: number | null;
  aspectRatio: string | null;
  containerHeight: number;
};

export enum LayoutPanelType {
  left = "left",
  right = "right",
}

export interface LayoutSliceData {
  leftPanel: PanelInfos;
  rightPanel: PanelInfos;
  player: PlayerInfos;
  searchOpen: boolean;
  drawerOpen: boolean;
  draggingId: any;
  draggingIds: number[];
  leftMounted: boolean;
  rightMounted: boolean;
}

const initialState: LayoutSliceData = {
  leftPanel: { intialWidth: 400, open: false, pinned: false, activeId: null },
  rightPanel: { intialWidth: 400, open: false, pinned: false, activeId: null },
  player: { responsive: true, aspectRatio: "16/9", height: null, containerHeight: 0 },
  searchOpen: false,
  drawerOpen: false,
  draggingId: null,
  draggingIds: [],
  leftMounted: false,
  rightMounted: false,
};

const layoutSlice = createSlice({
  name: "layoutSlice",
  initialState,
  reducers: {
    SetRightPanelOpen: (state, action) => {
      state.rightPanel.open = action.payload;
      state.rightPanel.pinned = false;
    },
    SetLeftPanelOpen: (state, action) => {
      state.leftPanel.open = action.payload;
      state.leftPanel.pinned = false;
    },
    SetRightPanelPinned: (state, action) => {
      state.rightPanel.pinned = action.payload;
    },
    SetLeftPanelPinned: (state, action) => {
      state.leftPanel.pinned = action.payload;
    },
    SetRightPanelActiveId: (state, action) => {
      state.rightPanel.activeId = action.payload;
    },
    SetLeftPanelActiveId: (state, action) => {
      state.leftPanel.activeId = action.payload;
    },
    SetPlayerHeight: (state, action) => {
      state.player.height = action.payload;
    },
    SetPlayerContainerHeight: (state, action) => {
      state.player.containerHeight = action.payload;
    },
    SetPlayerResponsive: (state, action) => {
      state.player.responsive = action.payload;
    },
    SetPlayerAspectRatio: (state, action) => {
      state.player.aspectRatio = action.payload;
    },
    SetSearchOpen: (state, action) => {
      state.searchOpen = action.payload;
    },
    SetDrawerOpen: (state, action) => {
      state.drawerOpen = action.payload;
    },
    SetDraggingId: (state, action) => {
      state.draggingId = action.payload;
    },
    SetDraggingIds: (state, action) => {
      state.draggingIds = action.payload;
    },
    SetLeftMounted: (state, action) => {
      state.leftMounted = action.payload;
    },
    SetRightMounted: (state, action) => {
      state.rightMounted = action.payload;
    },
  },
});

export const {
  SetRightPanelOpen,
  SetLeftPanelOpen,
  SetSearchOpen,
  SetLeftPanelPinned,
  SetRightPanelPinned,
  SetPlayerResponsive,
  SetPlayerAspectRatio,
  SetPlayerHeight,
  SetPlayerContainerHeight,
  SetDrawerOpen,
  SetLeftPanelActiveId,
  SetRightPanelActiveId,
  SetDraggingId,
  SetDraggingIds,
  SetLeftMounted,
  SetRightMounted,
} = layoutSlice.actions;

export const GetRightPanelInfos = (state: RootState) => {
  return state.layoutSlice.rightPanel;
};

export const GetLeftPanelInfos = (state: RootState) => {
  return state.layoutSlice.leftPanel;
};

export const GetPlayerInfos = (state: RootState) => {
  return state.layoutSlice.player;
};

export const GetSearchOpen = (state: RootState) => {
  return state.layoutSlice.searchOpen;
};

export const GetDrawerOpen = (state: RootState) => {
  return state.layoutSlice.drawerOpen;
};
export const GetDraggingId = (state: RootState) => {
  return state.layoutSlice.draggingId;
};
export const GetDraggingIds = (state: RootState) => {
  return state.layoutSlice.draggingIds;
};
export const GetLeftMounted = (state: RootState) => {
  return state.layoutSlice.leftMounted;
};
export const GetRightMounted = (state: RootState) => {
  return state.layoutSlice.rightMounted;
};
export default layoutSlice.reducer;
